import { Component, Inject, OnInit } from '@angular/core';
import { digger } from '@cbre/digger';
import { LookupRefService } from '@shared/services/lookup-ref.service';
import { EDITING_BOX_RECORDS, EDITING_BOX_SECTIONS, EditingBoxConfigItem } from './editing-box-overlay.config';
import { EditingBoxStreamService } from './editing-box-stream.service';

@Component({
  selector: 'miq-editing-box',
  templateUrl: './editing-box.component.html',
  styleUrls: ['./editing-box.component.scss'],
  standalone: false,
})
export class EditingBoxComponent implements OnInit {
  reportSection = [];

  constructor(
    @Inject(EDITING_BOX_SECTIONS) public sections: EditingBoxConfigItem[],
    @Inject(EDITING_BOX_RECORDS) public record: any,
    private streamService: EditingBoxStreamService,
    private lookupRef: LookupRefService
  ) {}

  onChange({ column, field, value }) {
    if (column && column.parent && column.parent.update) {
      const {
        entity: { id: recordId },
      } = this.record;
      this.streamService.pushChangeStream({
        recordId,
        column,
        field,
        value,
      });
    }
  }

  /**
   * Catures both, field and uom changes, since rdChange is a Column
   * object and is required by editing box event, it's being passed
   * as `column` attribute for the event
   *
   * @param rdChange Column
   */
  onUomChange(rdChange) {
    this.onChange({ ...rdChange, column: rdChange });
  }

  ngOnInit() {
    this.sections.forEach(section => {
      if (section.labelMode && section.labelMode === 'associated') {
        const recordItem = section.columns[0];
        recordItem.unit = section.columns[1];
        recordItem.value = digger(this.record, section.columns[0].field);
        recordItem.unit.value = digger(this.record, section.columns[1].field);
        this.getLookUp(section.columns[1].lookupCategory, recordItem);
        this.reportSection.push(recordItem);
      } else if (section.columns && section.columns.length > 0) {
        // labelMode = normal will have multiple columns
        section.columns.forEach(column => {
          this.reportSection.push(column);
        });
      }
    });
  }

  getLookUp(lookupCategory, recordItem) {
    this.lookupRef.loadDataFor(lookupCategory).subscribe(res => (recordItem.unit.values = res));
  }

  onArrayItemAdd(event) {
    const { record, item, field, column } = event;
    this.streamService.addArrayChangeStream(record, { item, field, column });
  }

  onArrayItemRemove(event) {
    this.streamService.removeArrayChangeStream(event);
  }
}
